class MediaNav extends HTMLElement {
    constructor() {
        super();
        this.currentSectionId = this.dataset.sectionId;
        this.players = [];
        this.init();
        this.initVideos();
    }

    init() {
        const items = this.querySelectorAll('.media-nav-item');
        items.forEach(item => {
            item.addEventListener('click', () => {
                const targetId = item.dataset.target;
                if (targetId) {
                    this.navigateToSection(targetId);
                }
            });
        });
    }

    initVideos() {
        const videoElements = this.querySelectorAll('.media-nav-item_video[data-plyr-provider="youtube"]');
        videoElements.forEach((videoEl, index) => {
            try {
                const player = new Plyr(videoEl, {
                    muted: true,
                    autoplay: true,
                    controls: [],
                    loop: { active: true },
                    playsinline: true,
                    youtube: {
                        autoplay: 1,
                        mute: 1,
                        rel: 0,
                        showinfo: 0,
                        controls: 0
                    },
                    // Quality settings from reference
                    quality: {
                        default: 1080,
                        options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240]
                    }
                });

                player.on('ready', (event) => {
                    player.muted = true;
                    player.play();
                });

                this.players.push(player);
            } catch (error) {
                console.error(`Failed to initialize Plyr on video ${index}:`, error);
            }
        });
    }

    getTemplateId(sectionId) {
        if (sectionId && sectionId.includes('__')) {
            return sectionId.split('__')[0];
        }
        return 'index';
    }

    navigateToSection(sessionId) {
        let elementId = '';
        const templateId = this.getTemplateId(this.currentSectionId);

        if (templateId !== 'index') {
            elementId = `shopify-section-${templateId}__${sessionId}`;
        }

        let el = null;
        if (elementId) {
            el = document.getElementById(elementId);
        }

        if (!el) {
            const fallbackSelector = `[id*="${sessionId}"]`;
            const sections = document.querySelectorAll(fallbackSelector);
            el = Array.from(sections).find(section =>
                section.id.startsWith('shopify-section-')
            );
        }

        if (el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }
}

if (!customElements.get('media-nav')) {
    customElements.define('media-nav', MediaNav);
}
